import { topics } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            探索当前最受关注的热门话题分类，找到你感兴趣的吃瓜方向
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#cards"
              className="group flex items-center gap-2.5 px-5 py-3 bg-background-100 border border-background-200/60 rounded-xl hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-8 h-8 rounded-lg bg-secondary-100 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
                <i className={`${topic.icon} text-sm text-secondary-600 group-hover:text-primary-500 transition-colors`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {topic.name}
              </span>
              <span className="text-xs text-foreground-400 flex items-center gap-1">
                <i className="ri-fire-line text-accent-500 text-xs"></i>
                {topic.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}